// 자료가 "올린 파일"인지 "등록한 링크"인지 한눈에 가르는 앞머리 아이콘 (티켓 #87).
//
// 이모지(📄🔗)를 쓰지 않는다 — 매장 PC 의 글꼴 사정에 따라 네모(□)로 깨져 무슨 자료인지
// 알 수 없게 된다(검증 브라우저에서 실제로 그렇게 나왔다). 이 앱의 다른 아이콘과 같은 SVG 로 그린다.

export default function LibraryKindIcon({
  kind,
  className = "",
}: {
  kind: "file" | "link" | "note";
  className?: string;
}) {
  return (
    <span
      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${
        kind === "link"
          ? "bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400"
          : "bg-gray-100 text-gray-500 dark:bg-white/10 dark:text-gray-300"
      } ${className}`}
      title={kind === "link" ? "링크" : kind === "note" ? "글" : "파일"}
      aria-hidden
    >
      {kind === "link" ? (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path
            d="M10 13.5a3.5 3.5 0 004.9.4l2.6-2.6a3.5 3.5 0 00-4.9-4.9l-1.2 1.2M14 10.5a3.5 3.5 0 00-4.9-.4l-2.6 2.6a3.5 3.5 0 004.9 4.9l1.2-1.2"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      ) : kind === "note" ? (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M7 4.5h10M7 9h10M7 13.5h7M5.5 3.5v17h13v-17z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
      ) : (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path
            d="M13.5 3.5H7A1.5 1.5 0 005.5 5v14A1.5 1.5 0 007 20.5h10a1.5 1.5 0 001.5-1.5V8.5l-5-5z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path d="M13.5 3.5V8.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        </svg>
      )}
    </span>
  );
}
